import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles((theme) => ({
  aaProgramContainer: {
    display: "flex",
    flexDirection: "column",
    margin: "32px auto 10px",
    borderRadius: "12px",
    justifyContent: "space-between",
    maxWidth: "540px",
    height: "fit-content",
    border: `1px solid ${colors.lightGrey}`,
    padding: "16px",
    boxSizing: "border-box",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "10px",
    }
  },
  customContentContainer: {
    maxWidth: "540px",
    padding: "16px",
    height: "fit-content",
    backgroundColor: colors.brightBlue,
    borderRadius: "8px"
  },
  customContentHeader: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.grey
  },
  customContentText: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: colors.mediumGrey,
    display: "inline-block",
    maxWidth: "100%",
    verticalAlign: "top",
  },
  
  customContentTextParagraph: {
    marginBottom: "16px"
  },

  customContentTextLastParagraph: {
    display: "ruby"
  },
  
  inlineReadMoreButton: {
    background: "none",
    border: "none",
    fontWeight: "600",
    fontSize: "12px",
    lineHeight: "18px",
    color: colors.grey,
    cursor: "pointer",
    padding: 0,
    display: "inline",
    marginLeft: "5px",
  },
  aaProgramRowOne: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxSizing: "border-box",
    borderBottom: `1px solid ${colors.lightGrey}`,
    margin: "0",
    padding: "0 0 16px 0",
    gap: "10px",
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  aaProgramRowTwo: {
    boxSizing: "border-box",
    padding: "16px 0",
    "& img": {
      width: "100%"
    }
  },
  aaProgramRowThree: {
    boxSizing: "border-box",
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin:"20px 0px 32px 0px"
  },
  bookOnText: {
    color: colors.paleGrey,
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "18px",
    marginBottom: 0,
    marginTop: 0,
  },
  programWebsiteText: {
    color: colors.grey,
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: 0,
    marginTop: 0,
    padding: "0px",
    margin: 0,
    textDecoration: "none"
  },
  accountDetailsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: 0
  },
  accountConnectedText: {
    color: colors.paleGrey,
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "18px",
    marginBottom: 0,
    marginTop: 0,
  },
  programAccountNumberText: {
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    width: "fit-content",
    padding: "0 8px 0 0"
  },
  programAccountConnectedDate: {
    color: colors.paleGrey,
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "18px",
    width: "fit-content",
    padding: 0
  },
  programWebsiteContainer: {
    padding: "0px"
  },
  columnRight: {
    
  },
  connectButtonContainer: {
    width: "auto",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%",
      padding: 0
    }
  },
  connectButton: {
    width: "fit-content",
    height: "fit-content",
    whiteSpace: "nowrap"
  },
  faqTitleText: {
    color: colors.grey,
    fontWeight: "600",
    fontSize: "12px",
    lineHeight: "18px",
    marginBottom: 0,
    marginTop: 0,
    padding: 0
  },
  faqDescriptionText: {
    color: colors.inactiveGrey,
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    marginBottom: 0,
    marginTop: 0,
    padding: 0
  },
  faqDescriptionText2: {
    color: colors.inactiveGrey,
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    marginBottom: 0,
    marginTop: "12px",
    padding: 0
  },
  faqContainer: {
    padding: "0px 16px 16px 16px"
  },
  faqContainerBottom: {
    padding: "0px 16px"
  },
  loadingState: {
    pointerEvents: "none",
    backgroundColor: `${colors.white} !important`,
    border: "none",
    display: "flex",
    justifyContent: "center",
    width: "fit-content"
  },
  delinkButton: {
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    alignSelf: "center",
    color: colors.error700
  },
  delinkSpinner: {
    margin: 0,
    left: "unset"
  },
}));

export default styles;
